export default __webpack_public_path__ + "static/besace.mobile.inspirations-cca198a92651c5120c16f23f3c22433e.jpg";